import React from 'react';
import PropTypes from 'prop-types';

import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'components/empty_state';

export default function VoucherEmptyState({ onClick }) {
  return (
    <EmptyState
      buttonText="Create Voucher"
      header="This deal does not have a voucher"
      icon={faFileInvoiceDollar}
      subheader="Create a draft voucher to get started"
      onButtonClick={onClick}
    />
  );
}

VoucherEmptyState.propTypes = {
  onClick: PropTypes.func,
};
